import { useAppSelector } from '../store/hooks';
import { HomeFeedEngine } from '../types/product.types';

export const useAttributionOrigin = (
  productSlug: string,
): { searchGuid?: string; recommendationId?: string; recommendationEngine?: HomeFeedEngine } => {
  const {
    activeSearchGuid,
    activeRecommendationId,
    activeRecommendationEngine,
    productSlug: originProductSlug,
  } = useAppSelector(({ searchSession }) => searchSession);

  if (!productSlug || productSlug !== originProductSlug) {
    return {};
  }

  if (activeSearchGuid) {
    return { searchGuid: activeSearchGuid };
  }

  return {
    ...(activeRecommendationId && { recommendationId: activeRecommendationId }),
    ...(activeRecommendationEngine && { recommendationEngine: activeRecommendationEngine }),
  };
};
